import { useEffect, useState } from "react";

export const useTypewriter = (
    examples: string[],
    typingSpeed = 50,
    deletingSpeed = 10,
    pauseDuration = 2500,
) => {
    const [placeholder, setPlaceholder] = useState("");
    const [exampleIndex, setExampleIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const currentText = examples[exampleIndex];
        let timeout: NodeJS.Timeout;

        if (isDeleting) {
            if (charIndex > 0) {
                timeout = setTimeout(() => {
                    setPlaceholder(currentText.substring(0, charIndex - 1));
                    setCharIndex((prev) => prev - 1);
                }, deletingSpeed);
            } else {
                setIsDeleting(false);
                setExampleIndex((prev) => (prev + 1) % examples.length);
            }
        } else {
            if (charIndex < currentText.length) {
                timeout = setTimeout(() => {
                    setPlaceholder(currentText.substring(0, charIndex + 1));
                    setCharIndex((prev) => prev + 1);
                }, typingSpeed);
            } else {
                timeout = setTimeout(() => {
                    setIsDeleting(true);
                }, pauseDuration);
            }
        }

        return () => clearTimeout(timeout);
    }, [charIndex, isDeleting, exampleIndex, examples, typingSpeed, deletingSpeed, pauseDuration]);

    return placeholder;
};
